import React from 'react';

function TermsAndConditionSection() {
  return (
    <div className="terms-container">
      <h1>Terms and Conditions</h1>
      
      <section className="terms-section">
        <h2>1. Acceptance of Terms</h2>
        <p>By accessing and using this prediction service, you acknowledge that you have read, understood, and agree to be bound by these terms and conditions.</p>
      </section>

      <section className="terms-section">
        <h2>2. Service Description</h2>
        <p>We provide sports prediction information for entertainment purposes only. Our predictions are based on analysis of historical data and should not be considered as guaranteed outcomes.</p>
      </section>

      <section className="terms-section">
        <h2>3. Disclaimer</h2>
        <p>All predictions are provided "as is" without warranty of any kind. We are not responsible for any losses incurred based on our predictions. Betting involves risk and should be done responsibly.</p>
      </section>

      <section className="terms-section">
        <h2>4. User Responsibilities</h2>
        <ul>
          <li>Users must be of legal age to engage in sports betting in their jurisdiction</li>
          <li>Users are responsible for their own betting decisions</li>
          <li>Users must comply with local laws and regulations regarding sports betting</li>
        </ul>
      </section>

      <section className="terms-section">
        <h2>5. Limitation of Liability</h2>
        <p>We shall not be liable for any direct, indirect, incidental, special, or consequential damages resulting from the use or inability to use our services.</p>
      </section>

      <section className="terms-section">
        <h2>6. Changes to Terms</h2>
        <p>We reserve the right to modify these terms at any time. Continued use of the service after changes constitutes acceptance of new terms.</p>
      </section>

      <section className="terms-section">
        <h2>7. Contact Information</h2>
        <p>For questions regarding these terms, please contact us at [Your Contact Information].</p>
      </section>
    </div>
  );
}

export default TermsAndConditionSection;